import React from 'react';
import { cloneChildrenWithProps } from '../../../jsCore/utils/reactUtils';
export const FanvoiceList = ({ blockName, modifier, children }) => {
  const className = `${blockName}__container`;
  return (
     <ul className={ `${className}` }>
        { cloneChildrenWithProps(children, { blockName, modifier }) }
     </ul>
  );
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fanvoice/components/fanvoiceList.js